module.exports = __webpack_public_path__ + "static/final_infographic-1d444c052e099af80c1bb0b94c3186b3.png";